module.exports = __webpack_public_path__ + "static/media/sayalee_khedekar.5a1e4400.png";